import PrivateRoute from "./ProtectedRoute";

export default PrivateRoute;
